import {
  IOrganization,
  IOrganizationDetail,
  IOrganizationCreate,
  IOrganizationUpdate,
  IOrganizationPatch,
} from '../models/organization';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private apiService: ApiService) {}
  readonly organizationsRoot = 'api/organizations';

  getOrganizations(active?: boolean) {
    const queryParams = active !== undefined ? { active: active.toString() } : undefined;
    const fullAPIUrl = this.apiService.buildFullURL(this.organizationsRoot, '', queryParams);
    return this.apiService.get<IOrganization[]>(fullAPIUrl, { withCredentials: true });
  }

  getOrganizationDetail(id: number): Observable<IOrganizationDetail> {
    const fullAPIUrl = this.apiService.buildFullURL(this.organizationsRoot, `${id}/`);
    return this.apiService.get<IOrganizationDetail>(fullAPIUrl, { withCredentials: true });
  }

  createOrganization(organization: IOrganizationCreate): Observable<IOrganization> {
    const fullAPIUrl = this.apiService.buildFullURL(this.organizationsRoot, '');
    return this.apiService.post<IOrganization>(fullAPIUrl, organization, { withCredentials: true });
  }

  updateOrganization(organization: IOrganizationUpdate): Observable<IOrganization> {
    const fullAPIUrl = this.apiService.buildFullURL(this.organizationsRoot, `${organization.id}/`);
    return this.apiService.put<IOrganization>(fullAPIUrl, organization, { withCredentials: true });
  }

  patchOrganization(id: number, patch: IOrganizationPatch): Observable<IOrganization> {
    const fullAPIUrl = this.apiService.buildFullURL(this.organizationsRoot, `${id}/`);
    return this.apiService.patch<IOrganization>(fullAPIUrl, patch, { withCredentials: true });
  }

  deleteOrganization(id: number): Observable<void> {
    const fullAPIUrl = this.apiService.buildFullURL(this.organizationsRoot, `${id}/`);
    return this.apiService.delete<void>(fullAPIUrl, { withCredentials: true });
  }
}
